<template>
  <div v-if="model && options">
    <md-divider />
    <p class="uc">{{ $t('labels.client') }}</p>
    <div style="height: 260px">
      <treeselect
        :max-height="220"
        :multiple="false"
        :value="selection"
        :options="options"
        :always-open="true"
        :placeholder="$t('actions.select')"
        @input="onTreeselectInput"
      />
    </div>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import api from '@/api'

export default {
  name: 'InputClient',

  components: { Treeselect },

  props: {
    value: Object,
    name: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    model: null,
    options: [],
    selected: null,
  }),

  async mounted() {
    this.model = {
      [this.name]: [],
      ...this.value,
    }

    this.selected = this.value[this.name] || []

    let opts = []
    const [err, entities] = await api.get('clients').send()
    if (err) return

    const newarr = entities
    newarr.map((e) => {
      opts.push({
        id: e._id,
        label: e.title,
      })
    })
    this.options = opts
  },

  methods: {
    onTreeselectInput(val) {
      this.selected = val
    },
  },

  watch: {
    value: {
      deep: true,
      handler() {
        this.model = {
          ...this.model,
          ...this.value,
        }
      },
    },

    selected() {
      this.model[this.name] = this.selected
      this.$emit('input', this.model)
    },
  },
}
</script>
